import { useEffect, useRef, useState, createContext, useContext, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import Reviews from "@/components/site/Reviews";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import QuoteDialog from "@/components/site/QuoteDialog";
import AskExpertDialog from "@/components/site/AskExpertDialog";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

function App() {
  const lenisRef = useRef(null);
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [expertOpen, setExpertOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const target = el.getBoundingClientRect().top + window.scrollY - 80;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(target);
    } else {
      window.scrollTo({ top: target, behavior: "smooth" });
    }
  }, []);

  const ctx = {
    scrollToId,
    openQuote: () => setQuoteOpen(true),
    openExpert: () => setExpertOpen(true),
  };

  return (
    <SiteContext.Provider value={ctx}>
      <div className="App bg-[#171B22] text-white overflow-x-hidden">
        <Navbar />
        <main>
          <Hero />
          <Services />
          <WhyUs />
          <Reviews />
          <Contact />
        </main>
        <Footer />
        <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
        <AskExpertDialog open={expertOpen} onOpenChange={setExpertOpen} />
        <Toaster position="top-center" theme="dark" />
      </div>
    </SiteContext.Provider>
  );
}

export default App;
